/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { JobAtsLinkSummary } from './jobAtsLinkSummary';
import type { JobEmployerSummary } from './jobEmployerSummary';
import type { OrgPersonResponse } from './orgPersonResponse';
import type { StageResponse } from './stageResponse';

export interface JobResponse {
  id: string;
  title: string;
  description?: string | null;
  status: string;
  is_archived: boolean;
  wizard_step?: number;
  project_id?: string | null;
  job_manager_id?: string | null;
  job_manager?: OrgPersonResponse | null;
  employer_id: string;
  employer: JobEmployerSummary;
  candidate_count?: number;
  stages?: StageResponse[];
  ats_link?: JobAtsLinkSummary | null;
  created_at: string;
  updated_at: string;
}
